<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/team/member/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item :label="$t('xingming')">
            <el-input v-model="yt.conditions.name"></el-input>
          </el-form-item>
          <el-form-item :label="$t('gonghao')">
            <el-input v-model="yt.conditions.jobNo"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button @click="yt.get(1)" type="primary" plain="plain">
              {{ $t('sousuo') }}
            </el-button>
            <el-button @click="yt.clear({ orderBy: 'createTime desc' })">{{ $t('chongzhi') }} </el-button>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <el-button size="mini" @click="yt.showEditDialog('xinzeng', null, 'w1');setDefaultValue();" type="primary" v-if="utils.checkPower('web_employment_management_team_member_add_button')">
          {{ $t('xinzeng') }}
        </el-button>
      </template>
      <!-- 操作列 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="utils.checkPower('web_employment_management_team_member_delete_button')">
            <el-button :loading="store.state.global_loading" type="text" class="font-color-danger" @click="yt.remove(scope.row, '/web/team/member/delete')">{{ $t('shanchu') }}</el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增 -->
      <template v-if="yt.editObj.action == 'xinzeng'">
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth">
          <el-form-item :label="$t('renyuan')" required>
            <yi_cross_select :max="1" :selectTitle="'name,jobNo,orgId'" :component="'web_employment_management_employee_component'" :ids.sync="yt.editObj.empId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('banzuzhiwei')" required>
            <yi_dictionary_select :type="'HR_TEAM_POSITION'" :ids.sync="yt.editObj.teamPosition"> </yi_dictionary_select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false;">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="save" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: "web_employment_management_team_member",
  data(){
    return {
      columns: [
        { label: 'gonghao', prop: 'emp.jobNo', },
        { label: 'xingming', prop: 'emp.name', },
        { label: 'suoshuzuzhi', prop: 'teamOrg.name', },
        { label: 'banzuzhiwei', prop: 'teamPosition',type: 'dictionary',key: 'HR_TEAM_POSITION', },
        { label: 'caozuo', type: 'slot', width: 100, fixed: 'right', }
      ],
      teamId:null,
      team:null,
      ignoreFilterFlag: true,
    }
  },
  created() {
    this.team = this.$attrs.team;
    this.teamId = this.$attrs.team.id;
    setTimeout(() => {
      this.$set(this.yt.conditions,'teamId',this.teamId);
      this.$set(this.yt.conditions,'ignoreFilterFlag',this.ignoreFilterFlag);
      this.yt.get(1);
    }, 300);
  },
  methods: {
    setDefaultValue() {
      if(this.yt.editObj.teamId == null || this.yt.editObj.teamId == undefined){
        this.$set(this.yt.editObj,'teamId',this.teamId);
      }
    },
    save(){
      this.yt.req('POST', '/web/team/member/create');
    }

  },
}
</script>

<style scoped>

</style>